import React from 'react';
import BasicTable from '../../FinancialPositions/components/BasicTable';
import { getColDefs, genericFormatter } from '../../FinancialPositions/components/BasicTableUtils';

interface Props {
  rows: any[];
  cols?: any;
}

export const AdminBufferTable: React.FC<Props> = ({ rows, cols }) => {
  if (!rows || rows.length === 0) return null;

  const customFormatter = (data: any): React.ReactNode | undefined => genericFormatter(data);

  return (
    <BasicTable
      allRows={rows}
      columns={getColDefs(cols || rows[0], customFormatter, false)}
      options={{ cellClass: 'max-h-24 overflow-scroll', noBorders: true, noDataMsg: 'No buffer data' }}
    />
  );
};

export default AdminBufferTable;
